import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container, Button, Alert, Row, Col } from 'reactstrap';
import { AvForm, AvGroup, AvField } from 'availity-reactstrap-validation';
import i18n from '../i18next';

import { MESSAGE_LEVEL_ERROR } from "../utils/Constants";
import { changeLoginPassword, clearMessage, forgotPassword } from '../actions';
import LoginScreenLeftSide from './LoginScreenLeftSide';
import MenuuLogoSVG from '../images/MenuuLogoSVG';

class ForgottenPassScreen extends Component {
	constructor(props) {
		super(props);

		this.state = {
			email: ''
		};

		this.changeEmail = this.changeEmail.bind(this);
	}

	componentDidMount() {
		setTimeout(() => {
			if(document.getElementById('logo')){
				document.getElementById('logo').classList.add('showLogInLogo');
			}
		}, 1);
	}

	changeEmail({ target }) {
		this.setState({
			email: target.value
		})
	}

	sendForgotYourPassLink() {
		const email = this.state.email;
		this.props.forgotPassword(email);
	}

	renderMessage() {
		const { alertStyle } = styles;

		if (this.props.message.text !== undefined && this.props.message.text !== null && this.props.message.text !== '') {
			// Dismiss the message after 3 seconds because if you don't close it,  it appear again after you logged in.
			const errorMessage = (this.props.message.level === MESSAGE_LEVEL_ERROR);

			if (errorMessage) {
				setTimeout(() => {
					this.props.clearMessage();
				}, 3000);
			}

			const dismiss = this.props.clearMessage.bind(this);
			const color = (errorMessage) ? 'danger' : 'success';
			return (
				<div style={alertStyle}>
					<Alert color={color} toggle={dismiss}>
						{this.props.message.text}
					</Alert>
				</div>
			);
		} else {
			return (
				<div></div>
			);
		}
	}

	render() {
		const { loginScreenContainer, formContainer, loginButton, forgotPasswordText, column } = styles;
		const isLeftSideHidden = window.innerWidth <= 768;
		let additionalFormContainer = {}, additionalHeadingStyles = {};

		if (window.outerWidth <= 414) {
			additionalFormContainer.width = '90%';
			additionalFormContainer.padding = '0px 12px';
			additionalHeadingStyles.fontSize = 35;
		} else if (window.innerWidth <= 768) {
			additionalFormContainer.width = 410;
		}

		return (
			<Container fluid style={loginScreenContainer}>
				<Row style={{ height: '100%' }}>

					{
						isLeftSideHidden ?
							<a href='https://menuu.com' id='logo' className='logInLogo'>
								<MenuuLogoSVG
									width={150} height={150} fill={'#373737'}
								/>
							</a>
							: <LoginScreenLeftSide />
					}

					<Col sm={isLeftSideHidden ? 12 : 7} style={column}>
						<div style={Object.assign({}, formContainer, additionalFormContainer)}>
							<h2 style={Object.assign({}, { fontWeight: 600, lineHeight: '50px', fontSize: 45, marginTop: 0, marginBottom: 14 }, additionalHeadingStyles)}>Forgot password?</h2>

							<AvForm onValidSubmit={() => this.sendForgotYourPassLink()}>
								<AvGroup>
									<AvGroup>
										<p style={forgotPasswordText}>{i18n.t('screens:forgottenPassScreen.enterEmail')}</p>
									</AvGroup>
									<AvField
										className='loginFields'
										style={{ paddingLeft: 0, paddingBottom: 0, color: '#363636', fontSize: 18, lineHeight: '26px', border: 'none', borderBottomWidth: 1, borderBottomStyle: 'solid', borderBottomColor: '#b7b7b7' }}
										placeholder={i18n.t('common:form.email')}
										type="email" name="email"
										value={this.props.email}
										onChange={this.changeEmail.bind(this)}
										required
										errorMessage={i18n.t('common:validations.errorMsg')}
										// validate={{
										// 	pattern: {
										// 		value: '[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}$',
										// 		errorMessage: i18n.t('common:validations.errorMsgEmail')
										// 	}
										// }}
									/>
								</AvGroup>
								<br />
								<Button style={loginButton} className='loginBtn' >{i18n.t('screens:forgottenPassScreen.send')}</Button>
							</AvForm>
						</div>
					</Col>
				</Row>
				{this.renderMessage()}
			</Container>
		);
	}
}

const mapStateToProps = state => {
	return {
		message: state.message
	};
};

export default connect(mapStateToProps, { forgotPassword, changeLoginPassword, clearMessage })(ForgottenPassScreen);

let styles = {
	formContainer: {
		padding: 0,
		width: 420,
		margin: 'auto',
		fontFamily: 'neue-haas-grotesk-display, sans-serif',
		fontStyle: 'normal',
		fontWeight: 100
	},
	column: {
		display: 'flex',
		flexDirection: 'column',
		paddingBottom: 35
	},
	loginButton: {
		width: 112,
		height: 'auto',
		backgroundColor: '#363636',
		border: 'none',
		boxShadow: '0px 8px 20px 0px rgba(35, 31, 32, 0.27)',
		color: '#ffffff',
		fontFamily: 'neue-haas-grotesk-display, sans-serif',
		fontWeight: 600,
		fontSize: 22,
		lineHeight: '30px',
		padding: 20
	},
	forgotPasswordText: {
		fontSize: 14
	},
	alertStyle: {
		position: 'fixed',
		top: '70px',
		left: '0',
		right: '0',
		width: '400px',
		height: '50px',
		marginLeft: 'auto',
		marginRight: 'auto'
	},
	loginScreenContainer: {
		height: '100%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center'
	}
}


// WEBPACK FOOTER //
// ./src/components/ForgottenPassScreen.js